import gql from 'graphql-tag'
import { PRODUCT_AutoComplete_FRAGMENT } from './fragments.graphql'

export const GET_AUTOCOMPLETE = gql`
  ${PRODUCT_AutoComplete_FRAGMENT}
  query GetAutocompleteE4($searchPhrase: String!, $touchpoint: Touchpoint!) {
    autoComplete: autoCompleteE4(searchPhrase: $searchPhrase, touchpoint: $touchpoint) {
      searchPhrase
      products {
        ...AutocompleteProduct
      }
      recentlyViewed {
        ...AutocompleteProduct
      }
      relatedCategories {
        count
        category {
          name
          namePath
          pathSlug
        }
      }
      suggestions {
        title
        rank
        ticket
        url
      }
      recentSearches {
        title
        url
      }
      productHitCount
    }
  }
`
